import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"video, camera, movie, play"} maskId="square-filled-radius-0-stroke-1-IconVideo"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H16V9.19141L22 6.19141V17.8094L16 14.8094V20H2V4ZM16 13.6914L21 16.1914V7.80944L16 10.3094V13.6914Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVideo;
